import React from "react";
import RouterNavigateOverride from "../components/router-navigate-override.jsx";

function BasePage({ children }) {
  return <RouterNavigateOverride>{children}</RouterNavigateOverride>;
}

export default BasePage;
